/**
 * custom.js
 * Custom JavaScript functionality for the theme.
 */
console.log('custom.js loaded');

document.addEventListener('click', (event) => {
  const summary = event.target.closest('summary');
  if (!summary) return;

  const accordion = summary.closest('accordion-custom');
  if (!accordion || !accordion.details) return;

  // Exclude product filter/facets accordions
  if (
    accordion.classList.contains('facets__item') ||
    accordion.querySelector('.js-filter') ||
    accordion.querySelector('.mobile-facets__details')
  ) {
    return;
  }

  // In the capture phase, details.hasAttribute('open') is the state BEFORE the click toggles it.
  // If it's currently closed, it means the user clicked it to open it.
  if (!accordion.details.hasAttribute('open')) {
    const otherAccordions = document.querySelectorAll('accordion-custom');
    otherAccordions.forEach(other => {
      if (
        other !== accordion &&
        other.details &&
        other.details.hasAttribute('open') &&
        typeof other.transition === 'function' &&
        !other.classList.contains('facets__item') &&
        !other.querySelector('.js-filter') &&
        !other.querySelector('.mobile-facets__details')
      ) {
        // Temporarily override focus to prevent focus stealing when closing
        const originalFocus = other.summary ? other.summary.focus : null;
        if (other.summary) {
          other.summary.focus = () => { };
        }
        try {
          other.transition(false);
        } catch (e) {
          console.error('Error closing other accordion:', e);
        } finally {
          if (other.summary && originalFocus) {
            other.summary.focus = originalFocus;
          }
        }
      }
    });
  }
}, { capture: true });

// Smooth Scroll for Inline/Anchor Links
document.addEventListener('click', (event) => {
  const anchor = event.target.closest('a');
  if (!anchor) return;

  const href = anchor.getAttribute('href');
  if (!href) return;

  // Check if it's an anchor link pointing to an element on the current page
  let hash = '';
  if (href.startsWith('#')) {
    hash = href;
  } else if (href.startsWith('/#')) {
    hash = href.substring(1);
  } else if (href.startsWith('./#')) {
    hash = href.substring(2);
  } else {
    try {
      const url = new URL(anchor.href, window.location.href);
      if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) {
        hash = url.hash;
      }
    } catch (e) {
      // Ignore invalid URL parsing
    }
  }

  if (!hash || hash === '#' || hash === '#top') return;

  const targetElement = document.querySelector(hash);
  if (!targetElement) return;

  // Respect user prefers-reduced-motion setting
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  event.preventDefault();

  // Determine header height offset dynamically
  const header = document.querySelector('#header-component');
  let headerOffset = 0;
  if (header) {
    const stickyType = header.getAttribute('data-sticky-type');
    const stickyState = header.getAttribute('data-sticky-state');

    // Offset by header height if header is always sticky, or currently active/sticky
    if (stickyType === 'always' || (stickyType === 'scroll-up' && stickyState === 'active')) {
      headerOffset = header.offsetHeight;
    }
  }

  const elementPosition = targetElement.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerOffset - 20;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });

  // Update hash in URL history without jumping the page
  history.pushState(null, null, hash);
});

/**
 * Global click interceptor for href="#" or data-href="#" in header/navigation
 * Uses capture phase to prevent browser navigation / placing '#' in URL
 */
document.addEventListener('click', (event) => {
  const target = event.target.closest('a, summary, [data-href]');
  if (!target) return;

  const rawHref = target.getAttribute('href');
  const dataHref = target.getAttribute('data-href') || target.dataset?.href;
  const href = rawHref || dataHref;

  if (href === '#' || href === '/#' || href === 'javascript:void(0)' || rawHref === '#') {
    if (target.closest('.header, .header-block, .list-menu, .mega-menu, .header__inline-menu, .menu-drawer')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}, true);

/**
 * Remove clickability and treat as label for top nav and mega menu items with href="#" or data-href="#"
 * Scoped to header / navigation elements, including .mega-menu__link--level-2, .list-menu, etc.
 * Preserves anchor text for design consistency while removing click navigation and hover link underline.
 */
function initHeaderMenuLabels() {
  const headerSelectors = [
    '.header a[href="#"]',
    '.header a[data-href="#"]',
    '.header-block a[href="#"]',
    '.header-block a[data-href="#"]',
    '.mega-menu a[href="#"]',
    '.mega-menu a[data-href="#"]',
    '.list-menu a[href="#"]',
    '.list-menu a[data-href="#"]',
    '.mega-menu__link--level-2[href="#"]',
    '.mega-menu__link--level-2[data-href="#"]'
  ].join(', ');

  const dummyAnchors = document.querySelectorAll(headerSelectors);
  dummyAnchors.forEach((link) => {
    link.classList.add('is-disabled-label');
    link.classList.remove('link--hover-underline');
    link.removeAttribute('href');
    link.setAttribute('role', 'text');
    link.setAttribute('aria-disabled', 'true');

    const textNode = link.querySelector('.text');
    if (textNode) {
      textNode.classList.add('is-disabled-label-text');
    }
  });

  const summaries = document.querySelectorAll('.header summary, .header-block summary, .list-menu summary, .mega-menu summary');
  summaries.forEach((summary) => {
    const dataHrefNode = summary.querySelector('[data-href="#"]');
    if (dataHrefNode) {
      dataHrefNode.removeAttribute('data-href');
    }

    if (summary.getAttribute('data-href') === '#') {
      summary.removeAttribute('data-href');
    }

    const textNode = summary.querySelector('.text');
    if (dataHrefNode || summary.classList.contains('is-disabled-label-summary')) {
      summary.classList.add('is-disabled-label-summary');
      summary.classList.remove('link--hover-underline');
      if (textNode) {
        textNode.classList.add('is-disabled-label-text');
        textNode.classList.remove('header__menu-parent-link');
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderMenuLabels);
} else {
  initHeaderMenuLabels();
}
document.addEventListener('shopify:section:load', initHeaderMenuLabels);

// Observe DOM mutations for dynamically fetched mega menu content (<section-fetcher>)
const headerObserver = new MutationObserver(() => {
  initHeaderMenuLabels();
});
const headerEl = document.querySelector('.header, header, #header-component, .header-wrapper');
if (headerEl) {
  headerObserver.observe(headerEl, { childList: true, subtree: true });
}








// document.addEventListener('click', function (e) {
//   const link = e.target.closest('a[href="#chat"]');
//   if (!link) return;

//   e.preventDefault();

//   // Wait until the Shopify Inbox launcher exists
//   const launcher = document.querySelector('shopify-chat')
//     ?.shadowRoot
//     ?.querySelector('button');

//   if (launcher) {
//     launcher.click();
//   } else {
//     console.log('Shopify Inbox launcher not found.');
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  // Target any link pointing to #chat (matches your <a href="#chat">Live Chat</a>)
  document.querySelectorAll('a[href="#chat"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // stop the dead #chat jump

      const shopifyChat = document.querySelector('shopify-chat');

      if (shopifyChat) {
        const chatButton = shopifyChat.shadowRoot?.querySelector('button');
        if (chatButton) {
          chatButton.click();
        } else {
          // fallback: some Inbox versions expose an "open" attribute
          shopifyChat.setAttribute('open', '');
        }
      } else {
        console.warn('Shopify Inbox widget (<shopify-chat>) not found — check that Inbox is installed and the app embed is enabled in Theme Editor.');
      }
    });
  });
});